import React, { useState, useRef } from "react";
import "../../../css/DesignSystem/Buttons/Buttons.css";

const ButtonFile = ({ buttonText, onFileChange }) => {
  const [clicked, setClicked] = useState(false);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    setClicked(!clicked);
    fileInputRef.current.click(); // Trigger hidden file input
  };

  return (
    <div>
      <div
        className={`Button-Brand3 ${clicked ? "clicked" : ""}`}
        onClick={handleClick}
      >
        <div className="Button-Text">{buttonText}</div>
      </div>

      {/* Hidden File Input */}
      <input
        type="file"
        accept="application/pdf"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={onFileChange} // Call file change handler
      />
    </div>
  );
};

export default ButtonFile;
